import React from 'react';
import { Box, useTheme } from '@mui/material';
import PearsanaLogo from '../../../assets/images/pearsana-logo.svg';
import PearsanaLogoDark from '../../../assets/images/pearsana-logo-dark.svg';
import PearsanaIcon from '../../../assets/images/pearsana-icon.svg';
import PearsanaIconDark from '../../../assets/images/pearsana-icon-dark.svg';

const DefaultAd = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	return (
		<Box
			width={'100%'}
			height={'100%'}
			sx={{
				backgroundColor: isDark ? theme.palette.background.default : theme.palette.common.white,

				borderTop: `1px solid ${theme.palette.divider}`,

				transition: 'background-color 0.2s ease, box-shadow 0.2s ease',

				':hover': {
					cursor: 'pointer',
					backgroundColor: isDark ? theme.palette.action.selected : theme.palette.action.hover,
					boxShadow: theme.shadows[1]
				}
			}}
		>
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
				<img
					style={{ margin: '10px', height: '2.5rem', width: 'auto' }}
					src={isDark ? PearsanaLogoDark : PearsanaLogo}
					alt="Pearsana"
				/>

				<img
					src={isDark ? PearsanaIconDark : PearsanaIcon}
					style={{ margin: '10px', height: '2rem', width: 'auto' }}
					alt="Pearsana icon"
				/>
			</div>
		</Box>
	);
};

export default DefaultAd;
